exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.actions[data-v-7b800d8c] {\n  display: block;\n}\n.card[data-v-7b800d8c] {\n  margin-bottom: 16px;\n}\n.card-title[data-v-7b800d8c] {\n  border-bottom: 2px dotted #ccc;\n}\n.expand-button[data-v-7b800d8c] {\n  color: #0d73d8;\n  text-transform: initial;\n}\n", ""]);

